// Import here Polyfills if needed. Recommended core-js (npm i -D core-js)
// import "core-js/fn/array.find"
// import "core-js/fn/Promise"
// ...
// import uuid = require("uuid/v4");

import uuid from "uuid/v4";
// import JsSdkInterface from "./interface/JsSdkInterface";
import { ReadFileParams, StatusBarParams, VivoDetectionParams, ApplyPermissionParams, AddCalendarParams, SelectCalendarParams, DeleteCalendarParams, ReadSystemParams, PortfolioParams, SaveFileInDiskParams, ReadFileInDiskParams, ClientJumpParams, ChooseVideoParams, LogoutParams, LoginParams, StartAnyChatParams, ChooseImgParams, UploadFileparams, OpenParams, CloseParams, WxPayParams, OpenAppParams, goWechatCustomServiceParams } from "./types/SdkTypes";



class JsSDK {


	constructor() {

		//暴露全局对象
		(<any>window).$JSSDK = this;
		//供native调用，用来统一处理native的返回信息
		(<any>window).respFromNative = this.respFromNative;
		//触发deviceready事件,供native调用
		(<any>window).deviceReady = this.deviceReady;
		//全局对象，用于存放回调方法的的uuid
		(<any>window).respCallbacks = this.respCallbacks;
	}


	/**
	 * 全局对象，用于存放回调方法的的uuid
	 * @param resp 处理结果
	 */
	respCallbacks: any = {};

	/**
	 * 用于存放2011功能号H5往客户端注册场景对应回调
	 * @param options 参数
	 */
	sceneRespCallbacks: any = {};


  /**
   *  用于佣金宝内，简易判断当前版本是否不小于目标版本。
   *  不接受字符等语义版本号，注意使用场景限制
   *
   * @param {string} currentVersion 当前版本号
   * @param {string} targetVersion 目标版本号 如6.05.001
   */
   isVersionSupport(currentVersion:string, targetVersion:string) {
    function versionStrToNumber(str:string) {
      // 6.05.001转Number 600050001
      let version = 0;
      str.split('.')
        .map(Number)
        .concat([0, 0, 0])
        .slice(0, 3)
        .map(function (ele: any) {
          version = version * 10000 + ele;
        });
      return version;
    }
    const current = versionStrToNumber(currentVersion);
    const target = versionStrToNumber(targetVersion);
    return current >= target;
  }

	/**
	 * 供native调用，用来统一处理native的返回信息
	 * @param resp 处理结果
	 */
	respFromNative = (data: any, callbackId: string): void => {
		if (callbackId) {
			//取出回调
			const respCallback = (<any>window).respCallbacks[callbackId];
			//调用前端回调
			typeof respCallback === "function" && respCallback(data);
			delete (<any>window).respCallbacks[callbackId];
		} else {
			console.log("native resp failed");
		}
	}


	/**
	 * 触发deviceready事件,供native调用
	 * @function deviceReady
	 */
	deviceReady = (): void => {
		const drEvent = document.createEvent("Event");
		drEvent.initEvent("deviceready", true, true);
		document.dispatchEvent(drEvent);
	}

	/**
	 * 监听native桥接，桥接成功后执行回调函数
	 * @function ready
	 * @param {function} onDeviceReady 回调函数
	 */
	ready = (): Promise<object> => {

		return new Promise(
			(resolve: (value: object | undefined) => void, reject: (value: string) => void) => {
				//如果已有桥接对象，直接resovle;如果没有桥接对象，注册监听
				const userAgent = navigator ? (navigator.userAgent ? navigator.userAgent : '') : '';
				const isWKWebView = userAgent.indexOf('ios/wkwebview') > -1;
				let isInitDevice = false;
				if (isWKWebView) {
					isInitDevice = typeof (<any>window).webkit.messageHandlers.yjbInterface === 'object' && typeof (<any>window).webkit.messageHandlers.yjbInterface.postMessage === 'function';
				} else {
					isInitDevice = typeof (<any>window).yjbInterface === 'object' && typeof (<any>window).yjbInterface.execute === 'function';
				}
				//如果已有桥接对象，直接resovle;如果没有桥接对象，注册监听
				if (isInitDevice) {
					resolve({});
				} else {
					document.addEventListener('deviceready', function () {
						if ((<any>window).webkit.messageHandlers.yjbInterface ||
							(<any>window).yjbInterface) {
							resolve({});
						}
					}, false);
				}
			}
		);


	}

	/**
	 * 调用native功能
	 * @param funcId native功能号
	 * @param {string} param 入参
	 * @param respCallback 回调
	 * @param noNativeInterfaceAvailable 未桥接的回调
	 */
	exec = (
		funcId: number,
		param: object,
		respCallback: object,
		noNativeInterfaceAvailable: object
	): void => {

		function randomArr(startCount: number, maxCount: number): number[] {
			let arr = [];
			for (let i = startCount; i < maxCount; i++) {
				arr.push(Math.floor(Math.random() * 10 + 1));
			}
			return arr;
		}
		const callbackId = uuid({ random: randomArr(0, 16) }).replace(/-/g, "");
		// const callbackId = 'todo';

		//以请求id为键，将回调放入回调列表
		(<any>window).respCallbacks[callbackId] = respCallback;

		const userAgent = navigator ? (navigator.userAgent ? navigator.userAgent : '') : '';
		const isWKWebView = userAgent.indexOf('ios/wkwebview') > -1;
		if (isWKWebView) {
			if ((<any>window).webkit.messageHandlers.yjbInterface == {} || (<any>window).webkit.messageHandlers.yjbInterface == undefined || (<any>window).webkit.messageHandlers.yjbInterface.postMessage == undefined) {
				console.error('未与native进行桥接！');
				typeof noNativeInterfaceAvailable === "function" &&
					noNativeInterfaceAvailable(new ReferenceError("未与native进行桥接！"));
				return;
			}
			(<any>window).webkit.messageHandlers.yjbInterface.postMessage({ functionId: funcId, param: JSON.stringify(param), callbackId: callbackId });
		} else {
			//当yjbInteface未被有效绑定时，undefined会导致js报错，所以这个检测很有必要
			if ((<any>window).yjbInterface == {} || (<any>window).yjbInterface == undefined || (<any>window).yjbInterface.execute == undefined) {
				console.error('未与native进行桥接！');
				typeof noNativeInterfaceAvailable === "function" &&
					noNativeInterfaceAvailable(new ReferenceError("未与native进行桥接！"));
				return;
			}
			(<any>window).yjbInterface.execute(funcId, JSON.stringify(param), callbackId);
		}


	}

	/**
	 * native 读写操作
	 * @param code 功能号
	 * @param options 参数
	 * @returns {Promise}
	 * @private
	 */
	nativeIOOperation = async (code: number, options: object): Promise<object> => {

		await this.ready();
		return new Promise(
			(resolve: (value: object) => void, reject: (value: string) => void) => {
				this.exec(
					code,
					options,
					(data: object) => {
						resolve(data);
					},
					(e: string) => {
						reject(e);
					}
				);
			}
		);
	}

	/**
	 * native 功能号2011读写操作 H5往客户端注册场景对应回调
	 * 注意：回调中立即执行window.alert会阻塞IOS页面跳转
	 * @param options 参数
	 * @private
	 */
	native2011IOOperation = (options: object): void => {
		this.sceneRespCallbacks = {
			...this.sceneRespCallbacks,
			...options
		}
		this.nativeIOOperation(2011, this.sceneRespCallbacks);
	}

	/**
	 * 读取文件 1003
	 * @memberof NativeAPI
	 * @function readFile
	 * @param {ReadFileParams} param
	 * @returns {void}
	 */
	readFile = (param: ReadFileParams): void => {
		this.nativeIOOperation(1003, param);
	}

	/**
	 * 通过http/https向服务器post数据 1004
	 * @function uploadFile
	 * @param {ReadFileParams} param
	 * @returns {Promise}
	 */
	uploadFile = (param: UploadFileparams): Promise<object> => {
		return this.nativeIOOperation(1004, param);
	}

	/**
	 * 请求客户端系统参数 2000
	 * @function readSystemParameter
	 * @param {ReadSystemParams} param
	 * @returns {Promise}
	 */
	readSystemParameter = (param: ReadSystemParams): Promise<object> => {
		return this.nativeIOOperation(2000, param);
	}

	/**
	 * 获取系统版本号
	 * @function getSystemVersion
	 * @param {function} callback callback接收结果作为参数
	 */
	getSystemVersion = (): Promise<string | null> => {
		return new Promise(
			(resolve: (value: string | null) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					2000,
					{
						keys: ['systemVersion']
					}
				).then((data: any) => {
					let result = null;
					if (+data.code === 0) {
						result = data.result.systemVersion
					}
					resolve(result);
				});
			}
		);
	}

	/**
	 * 获取App版本号
	 * @function getSystemVersion
	 * @param {function} callback callback接收结果作为参数
	 */
	getAppVersion = (): Promise<string | null> => {
		return new Promise(
			(resolve: (value: string | null) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					2000,
					{
						keys: ['appVersion']
					}
				).then((data: any) => {
					let result = null;
					if (+data.code === 0) {
						result = data.result.appVersion
					}
					resolve(result);
				});
			}
		);
	}

	/**
	 * 获取UDID
	 * @function getSystemVersion
	 * @param {function} callback callback接收结果作为参数
	 */
	getUDID = (): Promise<string | null> => {
		return new Promise(
			(resolve: (value: string | null) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					2000,
					{
						keys: ['UDID']
					}
				).then((data: any) => {
					let result = null;
					if (+data.code === 0) {
						result = data.result.UDID
					}
					resolve(result);
				});
			}
		);
	}

	/**
	 * 获取UID
	 * @function getSystemVersion
	 * @param {function} callback callback接收结果作为参数
	 */
	getUID = (): Promise<string | null> => {
		return new Promise(
			(resolve: (value: string | null) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					2000,
					{
						keys: ['uid']
					}
				).then((data: any) => {
					let result = null;
					if (+data.code === 0) {
						result = data.result.uid
					}
					resolve(result);
				});
			}
		);
	}

	/**
	 * 获取hybrid接口版本号
	 * @function getSystemVersion
	 * @param {function} callback callback接收结果作为参数
	 */
	getInterfaceVersion = (): Promise<string | null> => {
		return new Promise(
			(resolve: (value: string | null) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					2000,
					{
						keys: ['interfaceVersion']
					}
				).then((data: any) => {
					let result = null;
					if (+data.code === 0) {
						result = data.result.interfaceVersion
					}
					resolve(result);
				});
			}
		);
	}

	/**
	 * 打开新的webview 2007 2008
	 * @function openPage
	 * @param {OpenParams} params 参数
	 *   　　url	      {string}	当前需要打开的url地址
	 *   　　fullScreen	{number}	是否全屏展示 0-否，1-是  在展示资讯内容的时候有需要全屏展示
	 *   　　title	    {string}	页面的标题，如果不传或者传空，在load结束时，使用H5的标题。
	 *   　　leftType	  {number}	"按钮类型 v0-没有按钮  1-返回 98-图片自定义(设置按钮为图片格式)" 99-自定义(设置为默认底图，显示对应文本)"
	 *   　　rightType	{number}	类型同上
	 *   　　leftText	  {string}	当type=98时图片的地址，当type=99时按钮标题
	 *   　　rightText	{string}	当type=98时图片的地址，当type=99时右边按钮标题
	 *   　　leftJS	    {string}	点击左边按钮，调用的js函数名或者js语句块，客户端直接调用即可，如果是函数，H5传值需为”functionName()”而不是functionName。
	 *   　　rightJS	  {string}	点击右边按钮，调用的js函数名或者js语句块，客户端直接调用即可，如果是函数，H5传值需为”functionName()”而不是functionName。
	 *   　　leftURL	  {string}	点击左边按钮，跳转的链接地址，未设置leftJS有效
	 *   　　rightURL	  {string}	点击右边按钮，跳转的链接地址，未设置rightJS有效
	 *   　　animated   {number}  跳转是否有动画，0为没有，1为有
	 *   　　showLoadingPage   {number}    0:不显示loading效果，1：显示loading效果
	 * @param {boolean} needCloseCurrentView 是否需要关闭当前webview
	 */
	openPage = (params: OpenParams, needCloseCurrentView?: boolean): void => {
		this.nativeIOOperation(needCloseCurrentView ? 2007 : 2008, params);
	}

	/**
   * 定制页面标题和左右按钮 2012
   * @function openPage
   * @param {OpenParams} params 参数
   *   　	fullScreen	{number}	是否全屏展示 0-否，1-是  在展示资讯内容的时候有需要全屏展示
   *   　	title	    {string}	页面的标题，如果不传或者传空，在load结束时，使用H5的标题。
	 * 			titleColor  {string} 标题字体的颜色， 默认#fff
	 * 			subtitleColor {string} 副标颜色
   *   　	leftType	  {number}	"按钮类型 v0-没有按钮  1-返回 98-图片自定义(设置按钮为图片格式)" 99-自定义(设置为默认底图，显示对应文本)"
   *   　	rightType	{number}	类型同上
   *   　　leftText	  {string}	当type=98时图片的地址，当type=99时按钮标题
   *   　　rightText	{string}	当type=98时图片的地址，当type=99时右边按钮标题
   *   　　leftJS	    {string}	点击左边按钮，调用的js函数名或者js语句块，客户端直接调用即可，如果是函数，H5传值需为”functionName()”而不是functionName。
   *   　　rightJS	  {string}	点击右边按钮，调用的js函数名或者js语句块，客户端直接调用即可，如果是函数，H5传值需为”functionName()”而不是functionName。
   *   　　leftURL	  {string}	点击左边按钮，跳转的链接地址，未设置leftJS有效
   *   　　rightURL	  {string}	点击右边按钮，跳转的链接地址，未设置rightJS有效
   *   　　animated   {number}  跳转是否有动画，0为没有，1为有
   *   　　showLoadingPage   {number}    0:不显示loading效果，1：显示loading效果
   * @param {boolean} needCloseCurrentView 是否需要关闭当前webview
   */
	setTitle = (params: OpenParams): void => {
		this.nativeIOOperation(2012, params);
	}

	/**
   * 关闭当前webview 2009
   * @function closePage
   * @param {CloseParams} type 类型
   *    　　0	    返回到客户端页面堆栈中的上一个页面(默认为0)
   *    　　1	    返回到自选首页
   *    　　2	    返回到行情首页
   *    　　3	    返回到普通交易首页
   *    　　4	    返回到信用交易首页
   *    　　5	    返回到首页
   *    　　6	    返回到自选-组合
   *    　　7	    返回到“我的“首页
   *        8     返回到"理财"首页
   *    　　98	   返回到指定页面，需传第二个参数，指定返回的backUrl
   *       99     自定义返回页面（仅支持web页面跳转）
   *
   * @param {object} args 其他传参
   *      当type=98时，定义backUrl为具体返回url
   *
   */
	closePage = (params: CloseParams): void => {
		if (!params.type) params.type = 0;
		Object.assign({ type: 0 }, params);
		this.nativeIOOperation(2009, params);
	}

	/**
		* 弹出提示框 3003
		* @function showAlert
		* @param {string} content 显示内容
		* @param {string} title 显示标题
		* @param {function} success 点击确认后回调
		*/
	showAlert = (content: string, title?: string, success?: Function): void => {
		this.nativeIOOperation(3003, {
			content: `${content}`,
			buttonTitle: title || '我知道了'
		}
		).then((data: any) => {
			if (+data.code === 0) {
				success && success(data.result);
			}
		});
	}
	/**
	 * 弹出确认提示框
	 * @function showConfirm
	 * @param {string} content 显示内容
	 * @param {function} onConfirm 点击确定后回调
	 * @param {function} onCancel 点击取消后回调
	 * @param {string} confirmTitle 确定键标题
	 * @param {string} cancelTitle 取消键标题
	*/
	showConfirm = (content: string, onConfirm: Function, onCancel: Function, title?: string, cancelTitle?: string): void => {

		this.nativeIOOperation(
			3003,
			{
				content: content,
				buttonTitle: title || '确定',
				otherButtonTitle: cancelTitle || '取消'
			}
		).then((data: any) => {
			if (+data.code === 0) {
				if (data.result && data.result.clicked === 0) {
					typeof onConfirm === 'function' && onConfirm(data.result)
				} else if (data.result.clicked === 1) {
					typeof onCancel === 'function' && onCancel(data.result)
				}
			}
		});


	}
	/**
	 * onAppear 2011
	 * @function onSkinChanged
	 * @param {any} fn
	 */
	onSkinChanged = (fn: any): void => {
		if (typeof fn !== 'function') this.showAlert('参数只能为function类型', '');
		(<any>window).yjbsdk = (<any>window).yjbsdk || {};
		(<any>window).yjbsdk.onPageSkinChanged = fn;
		this.native2011IOOperation({ 'onSkinChanged': 'window.yjbsdk.onPageSkinChanged(skinType)' });
	}

	/**
	 * onAppear 2011
	 * 注意：回调中立即执行window.alert会阻塞IOS页面跳转
	 * @function onAppear
	 * @param {any} fn
	 */
	onAppear = (fn: any): void => {
		if (typeof fn !== 'function') this.showAlert('参数只能为function类型', '');
		(<any>window).yjbsdk = (<any>window).yjbsdk || {};
		(<any>window).yjbsdk.onPageAppear = fn;
		// this.nativeIOOperation(2011, { 'onAppear': 'window.yjbsdk.onPageAppear()' });
		this.native2011IOOperation({ 'onAppear': 'window.yjbsdk.onPageAppear()' });
	}
	/**
	 * onDisappear 2011
	 * 注意：回调中立即执行window.alert会阻塞IOS页面跳转
	 * @function onDisappear
	 * @param {function} fn
	 */
	onDisappear = (fn: any): void => {
		if (typeof fn !== 'function') this.showAlert('参数只能为function类型', '');
		(<any>window).yjbsdk = (<any>window).yjbsdk || {};
		(<any>window).yjbsdk.onPageDisappear = fn;
		// this.nativeIOOperation(2011, { 'onDisappear': 'window.yjbsdk.onPageDisappear()' });
		this.native2011IOOperation({ 'onDisappear': 'window.yjbsdk.onPageDisappear()' });
	}
	/**
	 * onClose 2011
	 * 注意：回调中立即执行window.alert会阻塞IOS页面跳转
	 * @function onClose
	 * @param {function} fn
	 */
	onClose = (fn: any): void => {
		if (typeof fn !== 'function') this.showAlert('参数只能为function类型', '');
		(<any>window).yjbsdk = (<any>window).yjbsdk || {};
		(<any>window).yjbsdk.onPageClose = fn;
		// this.exec(2011, { 'onClose': 'window.yjbsdk.onPageClose()' }, {}, {});
		this.native2011IOOperation({ 'onClose': 'window.yjbsdk.onPageClose()' });
	}
	/**
	 * onBackKeyPressed 2011
	 * 注意：回调中立即执行window.alert会阻塞IOS页面跳转
	 * @function onBackKeyPressed
	 * @param {any} fn
	 */
	onBackKeyPressed = (fn: any): void => {
		if (typeof fn !== 'function') this.showAlert('参数只能为function类型', '');
		(<any>window).yjbsdk = (<any>window).yjbsdk || {};
		(<any>window).yjbsdk.onBackKeyPressed = fn;
		// this.nativeIOOperation(2011, { 'onBackKeyPressed': 'window.yjbsdk.onBackKeyPressed()' });
		this.native2011IOOperation({ 'onBackKeyPressed': 'window.yjbsdk.onBackKeyPressed()' });
	}

	/**
	 * 拨打电话 3000
	 * @function call
	 * @param {string} phoneNumber 电话号码（座机、手机）
	 */
	call = (phoneNumber: string): void => {
		this.nativeIOOperation(3000, { phone: `${phoneNumber}` });
	}

	/**
	 * 客户端打开其它App 3002
	 * @function openApp
	 * @param {OpenAppParams} param
	 */
	openApp = (param: OpenAppParams): void => {
		this.nativeIOOperation(3002, param);
	}
	/**
	 * 选择照片 3004
	 * @function chooseImg
	 * @param {ChooseImgParams} param
	 *  {<br />
	 *  source: 0-从相册选择，1-拍照　<br />
	 *  front: 0-后置摄像头，1-前置摄像头<br />
	 *  size: 客户端需要将图片高或者宽中较大的一边，缩小到这个size，然后将另一边按比例缩放<br />
	 *  compressionQuality:JPEG压缩比例，范围为0.0-1.0。size和压缩比暂定1200和0.6，后续可调整。<br />
	 *  floatingLayer：　浮层类型，仅在source为1时生效。0没有，1身份证正面（人头），2身份证反面（国徽），3自拍头像。<br />
	 * }<br />
	 * @returns {Promise<object>} 返回值<br/>
	 *  code 0成功，1失败，2取消。<br />
	 *  result.data: base64编码的图片信息
	 */
	chooseImg = (param: ChooseImgParams): Promise<object> => {
		return this.nativeIOOperation(3004, param);
	}

	/**
	 * AnyChat视频见证 3005
	 * @function startAnyChat
	 * @param {StartAnyChatParams} param
	 * @returns  {Promise<object>}
	 */
	startAnyChat = (param: StartAnyChatParams): Promise<object> => {
		return this.nativeIOOperation(3005, param);
	}

	/**
	 * 二维码扫描 3007
	 * @function scanCode
	 * @returns  {Promise<object>}
	 */
	scanCode = (): Promise<object> => {
		return this.nativeIOOperation(3007, {});
	}
	/**
	 * 客户端本地录制视频 3009
	 * @function chooseVideo
	 * @param {ChooseVideoParams} param
	 *  {
	 *  front	number	0代表非前置（后置）摄像头，1代表前置摄像头。
	 *  width	number	视频宽度
	 *  height	number	视频高度
	 *  duration	number	视频最大长度，单位秒，默认-1，不限制视频长度。
	 *  bitRate	number	码率
	 *  fps	number	帧数
	 *  title	string	录制屏幕上方显示的标题（例如“请用标准普通话匀速朗读”）
	 *  content	string	录制屏幕上方显示的正文（例如“本人自愿在国金证券开户”）
	 * }
	 * @returns {Promise<object>} Promise<object>
	 *  code 0成功，1失败，2取消。
	 *  result.filePath: 客户端存储视频的本地路径。
	 *  result.fileSize: 视频文件大小
	 *  result.duration: 视频文件长度
	 */
	chooseVideo = (param: ChooseVideoParams): Promise<object> => {
		return this.nativeIOOperation(3009, param);
	}

	/**
		* 支付宝支付 3012
		* @function goAlipay
		* @param {String} order 对应支付宝支付的参数orderString
		* @returns {Promise<object>}  支付宝支付返回的信息
		*
		*/
	goAlipay = (order: string): Promise<object> => {

		return new Promise(
			(resolve: (value: object) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					3012,
					{ order: order }
				).then((data: any) => {
					let result = null;

					if (+data.code === 0) {
						result = data.result;
					}
					resolve(result);
				});
			}
		);
	}


	/**
	 * 微信支付 3013
	 * @function goWeChatPayment
	 * @param {String} appId 商家向财务通申请的appId
	 * @param {String} partnerId 商家向财务通申请的商家id
	 * @param {String} prepayId 预支付订单
	 * @param {String} nonceStr 随机串,防重发
	 * @param {String} timeStamp 时间串,防重发
	 * @param {String} packageStr 商家根据财付通文档填写的数据和签名
	 * @param {String} sign 商家根据微信开放平台文档对数据做的签名
	 * @param {WxPayParams} params // 微信支付参数
	 * @returns {Promise<object>} 微信支付返回的信息
	 */

	goWeChatPayment = (params: WxPayParams): Promise<object> => {
		return new Promise((resolve: (value: object) => void, reject: (value: string) => void) => {
			this.nativeIOOperation(3013, params).then((data: any) => {
				// 解决安卓，iOS返回数据格式不一致问题

				let payRes = (data.result || data) || {};
				payRes.code = payRes.errCode;
				payRes.errStr = data.message || '支付失败了~';
				resolve(payRes);
			});
		}
		);
	}

	/**
	 * 微信分享 3015
	 * @function goWeChatShare
	 * @param {any} param 分享参数 (第三方参数透传,请查看native文档)
	 * @returns {Promise<object>} 微信分享返回的信息
	 */
	goWeChatShare = (params: any): Promise<object> => {
		return this.nativeIOOperation(3015, params);
	}

	/**
	 * 金融登录-通用于获取uKey 4000, 扩展支持了fundAccount和版本号判断
	 * @function
	 * @param {LoginParams} params
	 * @param {Promise<object>}  结果:0 - 登录成功; 1 - 取消登录, 其他值-换登功能号返回
	 */
	login = (params: LoginParams): Promise<object> => {

		return new Promise(
			async (resolve: (value: object) => void, reject: (value: string) => void) => {
        let option = {
          type: params.type ? params.type : 1,
          needPassportId: params.needPassportId ? params.needPassportId : 1,
          needStockAccount: params.needStockAccount ? params.needStockAccount : 1,
          fundAccount: params.fundAccount || '',
        };
        let isUseNewLogin = false;
        if(params.fundAccount){
          // 根据版本支持再判断一次。暂定8.04.003
          const appVersion = await this.getAppVersion();
          if(appVersion){
            console.log('appVersion isis ' + appVersion);
            isUseNewLogin = this.isVersionSupport(appVersion, '8.04.003');
            console.log('isVersionSupport is ' + isUseNewLogin);
          }
        }
        console.log(`登录使用功能号：${isUseNewLogin? 4030: 4000}, 入参：${JSON.stringify(option)}`)
        // 4030新增的错误码： 100 当前帐号已经登录; -1000 type 不支持; -1001 url 不支持
				this.nativeIOOperation(
          isUseNewLogin? 4030: 4000,
          option
				).then((data: any) => {
					let result = data;
					result.errCode = data.code;
					result.errStr = data.message;
					resolve(result);
				});
			}
		);
	}

  /**
   * 登录代入资金账号-调用前需要判断版本号 4030
   * @function
   * @param {LoginParams} params
   * @param {Promise<object>}  结果:0 - 登录成功; 1 - 取消登录; -2 - 参数格式错误; 其他值-换登功能号返回
   */
  loginWithAccount = (params: LoginParams): Promise<object> => {
    // 8.04.003开始支持, 暂定
    return new Promise(
      async (resolve: (value: object) => void, reject: (value: string) => void) => {
        if(!params.fundAccount){
          resolve({errCode: -2, errStr: 'H5提示：参数格式错误'+ JSON.stringify(params)} );
          return;
        }
        // 对于loginType进行限制，只接收 1、2、16，即普通、信用、期权登录。非以上则返回错误。
        // 100 当前帐号已经登录; -1000 type 不支持; -1001 url 不支持
        this.nativeIOOperation(
          4030,
          {
            type: params.type ? params.type : 1,
            needPassportId: params.needPassportId ? params.needPassportId : 1,
            needStockAccount: params.needStockAccount ? params.needStockAccount : 1,
            fundAccount: params.fundAccount,
          }
        ).then((data: any) => {
          let result = data;
          result.errCode = data.code;
          result.errStr = data.message;
          resolve(result);
        });
      }
    );
  }

	/**
	 * 注销登录 4001
	 * @function logout
	 * @param {LogoutParams} param
	 *      登录类型： <br>
	 *              1-普通登录<br>
	 *              2-信用登录<br>
	 *              3-担保品划转登录（普通+信用）<br>
	 *              4-通行证passport登录<br>
	 *              5-普通+passort登录<br>
	 */
	logout = (param: LogoutParams): void => {
		this.nativeIOOperation(4001, param);
	}

	/**
	 * 客户端本地页面跳转 4002
	 * @function clientJump
	 * @param {ClientJumpParams} param
	 */
	clientJump = (params: ClientJumpParams): void => {
		this.nativeIOOperation(4002, params);
	}

	/**
	 * 完成适当性测评,关闭webview，继续登录前的操作 4009
	 * @function doneSuitability
	 * @param {number} loginType 登录类型 见：login
	 * @param {number} isValid  是否完成：0-未完成，1-已完成
	 */
	doneSuitability = (loginType: number, isValid: number): void => {
		this.nativeIOOperation(4009, { type: +loginType, valid: +isValid });
	}

	/**
	* 获取登录状态 4012
	* @function getLoginStatus
	* @param {function} callback callback接收结果作为参数
	*/
	getLoginStatus = (): Promise<number | null> => {
		return new Promise(
			(resolve: (value: number | null) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					4012,
					{
						keys: ['loginStatus']
					}
				).then((data: any) => {
					let result = null;
					if (+data.code === 0) {
						result = data.result.loginStatus
					}
					resolve(result);
				});
			}
		);
	}

	/**
	* 获取与channelId对应的ukey 4012
	* @function getUkeyByChannelId
	* @param {String} channelId 渠道编号
	* @returns {Promise<string>}  获取成功后，callback接收ukey作为参数（获取失败时，返回null）
	*/
	getUkeyByChannelId = (channelId: string): Promise<string> => {
		return new Promise(
			(resolve: (value: string) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					4012,
					{
						keys: ['ukeys']
					}
				).then((data: any) => {
					let ukey = null;
					if (+data.code === 0) {
						let ukeys = data.result && data.result.ukeys ? data.result.ukeys : {};
						ukey = ukeys[channelId];
					}
					resolve(ukey);
				});
			}
		);
	}

	/**
	 * 获取与channelId对应的userUKeys 4012
	 * @param {String} channelId 渠道编号
	 * @function getUserUKeys
	 * @returns {Promise<string>}  获取成功后，callback接收ukey作为参数（获取失败时，返回null）
	 */
	getUserUKeysByChannelId = (channelId: string): Promise<string> => {
		return new Promise(
			(resolve: (value: string) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					4012,
					{
						keys: ['userUKeys']
					}
				).then((data: any) => {
					let userUKey = null;
					let userUKeys = null;
					if (+data.code === 0) {
						userUKeys = data.result && data.result.userUKeys ? data.result.userUKeys : {};
						userUKey = userUKeys[channelId];
					}
					resolve(userUKey);
				});
			}
		);
	}

	/**
	 * user登录 4015
	 * 回调函数接收返回结果，结果:0 - 登录成功; 1 - 取消登录
	 * @function userLogin
	 * @returns {Promise<object>} 回调函数接收返回结果，结果:0 - 登录成功; 1 - 取消登录
	 */
	userLogin = (json?: Object): Promise<object> => {
		let params = { needUKey: 1 }
		if (json) {
			Object.assign(params, json);
		}
		return this.nativeIOOperation(4015, params)
	}


  /**
   * user登录用户登录（一键登录弹窗） 4028
   * 回调函数接收返回结果，结果:0 - 登录成功; 1 - 取消登录
   * @function userLogin
   * @returns {Promise<object>} 回调函数接收返回结果，结果:0 - 登录成功; 1 - 取消登录
   */
  userLoginModal = (json?: Object): Promise<object> => {
    let params = {}
    if (json) {
      Object.assign(params, json);
    }
    // 8.04.001开始支持
    return this.nativeIOOperation(4028, params)
  }

	/**
	 * 往客户端磁盘写文件-依赖内部环境 2004
	 * @param {SaveFileInDiskParams} param
	 * @function saveFileInDisk
	 * @returns {void}
	 */
	saveFileInDisk = (param: SaveFileInDiskParams): void => {
		this.nativeIOOperation(2004, param);
	}

	/**
	 * 读客户端磁盘文件-依赖内部环境 2005
	 * @param {ReadFileInDiskParams} param
	 * @function readFileInDisk
	 * @returns {Promise<object>}  文件内容
	 */
	readFileInDisk = (param: ReadFileInDiskParams): Promise<object> => {
		return new Promise(
			(resolve: (value: object) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					2005,
					param
				).then((data: any) => {
					let readData = null;
					if (+data.code === 0) {
						readData = data.result && data.result.data ? data.result.data : {};
					}
					resolve(readData);
				});
			}
		);
	}


	/**
	 *  获取PassportId-依赖内部环境 4004
	 * @param {SaveFileInDiskParams} param
	 * @function hybridGetPassport
	 * @returns {void}
	 */
	hybridGetPassport = (): Promise<object> => {
		return new Promise(
			(resolve: (value: object) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					4004,
					{ keys: ['passportId'] }
				).then((data: any) => {
					let passportId = null;
					if (+data.code === 0) {
						passportId = data.result && data.result.passportId ? data.result.passportId : null;
					}
					resolve(passportId);
				});
			}
		);
	}

	/**
	 * 获取usertId-依赖内部环境 4004
	 * @param {SaveFileInDiskParams} param
	 * @function hybridGetUserId
	 * @returns {void}
	 */
	hybridGetUserId = (): Promise<object> => {
		return new Promise(
			(resolve: (value: object) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					4004,
					{ keys: ['userId'] }
				).then((data: any) => {
					let userId = null;
					if (+data.code === 0) {
						userId = data.result && data.result.userId ? data.result.userId : null;
					}
					resolve(userId);
				});
			}
		);
	}

	/**
	 * 添加股票至自选股 4011
	 * @function addToPortfolio
	 * @param {PortfolioParams} param 参数
	 * @returns {Promise<object>} 返回值
	*/
	addToPortfolio = (param: PortfolioParams): Promise<object> => {
		if (!param.stockCode) throw new TypeError('stockCode is required');
		param.stockCode = `${param.stockCode}`;
		if (param.codeType) param.codeType = + param.codeType;

		return new Promise(
			(resolve: (value: any) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					4011,
					param
				).then((data: any) => {
					if (+data.code === 0) {
						resolve(data);
					} else {
						resolve(null);
					}

				});
			}
		);
	}

	/**
	 * 添加股票至自选股 4020
	 * @function addToPortfolio
	 * @param {PortfolioParams} param 参数
	 * @returns {Promise<object>} 返回值
	*/
	removePortfolio = (param: any): Promise<object> => {
		if (!param.stockCode) throw new TypeError('stockCode is required');
		param.stockCode = `${param.stockCode}`;
		if (param.codeType) param.codeType = + param.codeType;

		return new Promise(
			(resolve: (value: any) => void, reject: (value: string) => void) => {
				this.nativeIOOperation(
					4020,
					param
				).then((data: any) => {
					if (+data.code === 0) {
						resolve(data);
					} else {
						resolve(null);
					}

				});
			}
		);
	}

	/**
	 * 请求客户端非系统参数 4012
	 * @function readNoSystemParameter
	 * @param {ReadSystemParams} param
	 * @returns {Promise}
	 */
	readNoSystemParameter = (param: ReadSystemParams): Promise<object> => {
		return this.nativeIOOperation(4012, param);
	}

	/**
	 * 获取资金流向数据 4017
	 * @function getCapital
	 * @param {String} code 渠道编号
	 * @param {number} codeType 渠道编号
	 * @retruns {Promise<object>} 返回结果
	 */
	getCapital = (code: string, codeType: number): Promise<object> => {

		return new Promise(
			(resolve: (value: any) => void, reject: (value: string | null) => void) => {
				this.nativeIOOperation(
					4017,
					{ code: code, codeType: codeType }
				).then((data: any) => {
					let result = null;
					if (+data.code === 0) {
						result = data.result
						resolve(result);
					} else {
						resolve(result);
					}

				});
			}
		);
	}
	/**
	 * 调用银联继承的apple pay支付功能 3020
	 * @function appleUnionPay
	 * @param {String} tn 交易流水号
	 * @param {String} mID 苹果公司分配的商铺号
	 * @param {String} mode "00" 代表接入生产环境 "01"代表接入开发测试环境
	 * @retruns {Promise<object>} 返回结果
	 */
	appleUnionPay = (tn: string, mID: string, mode: string | null): Promise<object> => {
		return new Promise(
			(resolve: (value: any) => void, reject: (value: string | null) => void) => {
				this.nativeIOOperation(
					3020,
					{ tn: tn, mID: mID, mode: mode }
				).then((data: any) => {
					let result = null;
					if (+data.code === 0) {
						result = data.result
						resolve(result);
					} else {
						resolve(result);
					}

				});
			}
		);
	}
	/**
	 * 调用银联继承的apple pay支付功能 3021
	 * @function applePay
	 * @param {object} orderInfo orderInfo
	 * @param {String} mode "00" 代表接入生产环境 "01"代表接入开发测试环境
	 * @retruns {Promise<object>} 返回结果
	 */
	appleChinaPay = (orderInfo: object, mode: string | null): Promise<object> => {
		return new Promise(
			(resolve: (value: any) => void, reject: (value: string | null) => void) => {
				this.nativeIOOperation(
					3021,
					{ orderInfo: orderInfo, mode: mode }
				).then((data: any) => {
					let result = null;
					if (+data.code === 0) {
						result = data.result
						resolve(result);
					} else {
						resolve(result);
					}

				});
			}
		);
	}

	/**
	 * 设置statusBar样式 3016
	 * @function setStatusBar
	 * @param {StatusBarParams} param
	 * @returns {Promise<object>}
	 */
	setStatusBar = (param: StatusBarParams): Promise<object> => {
		return this.nativeIOOperation(3016, param);
	}

	/**
	 * 关闭webview的loading页面 3017
	 * @function closeLoading
	 * @returns {Promise<object>}
	 */
	closeLoading = (): Promise<object> => {
		return this.nativeIOOperation(3017, {});
	}

	//-----------------------------------------------

	/**
	 * 活体检测 3018
	 * @function VivoDetectionParams
	 * @param {VivoDetectionParams} param
	 * @returns {Promise<object>}
	 */
	vivoDetection = (param: VivoDetectionParams): Promise<object> => {
		return this.nativeIOOperation(3018, param);
	}
	/**
	 * 申请系统权限（安卓） 3019
	 * @function applyPermission
	 * @param {ApplyPermissionParams} param
	 * @returns {Promise<object>}
	 */
	applyPermission = (param: ApplyPermissionParams): Promise<object> => {
		return this.nativeIOOperation(3019, param);
	}

	/**
	 * 添加日历事件 3022
	 * @function addCalendar
	 * @param {AddCalendarParams} param
	 * @returns {Promise<object>}
	 */
	addCalendar = (param: AddCalendarParams): Promise<object> => {
		return this.nativeIOOperation(3022, param);
	}

	/**
	 * 查询日历事件 3023
	 * @function selectCalendar
	 * @param {SelectCalendarParams} param
	 * @returns {Promise<object>}
	 */
	selectCalendar = (param: SelectCalendarParams): Promise<object> => {
		return this.nativeIOOperation(3023, param);
	}

	/**
	 * 删除日历事件 3024
	 * @function vivoDetection
	 * @param {DeleteCalendarParams} param
	 * @returns {Promise<object>}
	 */
	deleteCalendar = (param: DeleteCalendarParams): Promise<object> => {
		return this.nativeIOOperation(3024, param);
	}
	/*
	* @functionCode 功能号：3038
	* @description  保存图片到相册
	* @param {String} data 参数-图片地址（首先要对图片进行base64处理）
	* @param {Number} imageType 参数-图片类型0-jpg，1-png（安卓）
   */
	savePictureToPhone(data: string, imageType?: number): Promise<object> {
		return nativeIOOperation(3038, { data, imageType });
	}

	/**
	 * 跳转微信客服页面	 3039
	 * @function goWechatCustomService
	 * @param {goWechatCustomServiceParams} param
	 * @retruns {Promise<object>} 返回结果
	 */
	goWechatCustomService = (param: goWechatCustomServiceParams): Promise<object> => {
		return this.nativeIOOperation(3039, param);
	}

}

// module.exports = jssdk;

const jssdk = new JsSDK();
export default jssdk;
/**
 * 监听native桥接，桥接成功后执行回调函数
 * @function ready
 * @param {function} onDeviceReady 回调函数
 */
export const ready = jssdk.ready;
/**
 * 调用native功能
 * @param funcId native功能号
 * @param {string} param 入参
 * @param respCallback 回调
 * @param noNativeInterfaceAvailable 未桥接的回调
 */
export const exec = jssdk.exec;
/**
 * native 读写操作
 * @param code 功能号
 * @param options 参数
 * @returns {Promise}
 * @private
 */
export const nativeIOOperation = jssdk.nativeIOOperation;
/**
 * 读取文件 1003
 * @memberof NativeAPI
 * @function readFile
 * @param {ReadFileParams} param
 * @returns {void}
 */
export const readFile = jssdk.readFile;
/**
 * 通过http/https向服务器post数据 1004
 * @function uploadFile
 * @param {ReadFileParams} param
 * @returns {Promise}
 */
export const uploadFile = jssdk.uploadFile;
/**
 * 请求客户端系统参数 2000
 * @function readSystemParameter
 * @param {ReadSystemParams} param
 * @returns {Promise}
 */
export const readSystemParameter = jssdk.readSystemParameter;
/**
 * 获取系统版本号
 * @function getSystemVersion
 * @param {function} callback callback接收结果作为参数
 */
export const getSystemVersion = jssdk.getSystemVersion;
/**
 * 获取App版本号
 * @function getSystemVersion
 * @param {function} callback callback接收结果作为参数
 */
export const getAppVersion = jssdk.getAppVersion;
/**
 * 获取UDID
 * @function getSystemVersion
 * @param {function} callback callback接收结果作为参数
 */
export const getUDID = jssdk.getUDID;
/**
 * 获取UID
 * @function getSystemVersion
 * @param {function} callback callback接收结果作为参数
 */
export const getUID = jssdk.getUID;
/**
 * 获取hybrid接口版本号
 * @function getSystemVersion
 * @param {function} callback callback接收结果作为参数
 */
export const getInterfaceVersion = jssdk.getInterfaceVersion;
/**
 * 打开新的webview 2007 2008
 * @function openPage
 * @param {OpenParams} params 参数
 *   　　url	      {string}	当前需要打开的url地址
 *   　　fullScreen	{number}	是否全屏展示 0-否，1-是  在展示资讯内容的时候有需要全屏展示
 *   　　title	    {string}	页面的标题，如果不传或者传空，在load结束时，使用H5的标题。
 *   　　leftType	  {number}	"按钮类型 v0-没有按钮  1-返回 98-图片自定义(设置按钮为图片格式)" 99-自定义(设置为默认底图，显示对应文本)"
 *   　　rightType	{number}	类型同上
 *   　　leftText	  {string}	当type=98时图片的地址，当type=99时按钮标题
 *   　　rightText	{string}	当type=98时图片的地址，当type=99时右边按钮标题
 *   　　leftJS	    {string}	点击左边按钮，调用的js函数名或者js语句块，客户端直接调用即可，如果是函数，H5传值需为”functionName()”而不是functionName。
 *   　　rightJS	  {string}	点击右边按钮，调用的js函数名或者js语句块，客户端直接调用即可，如果是函数，H5传值需为”functionName()”而不是functionName。
 *   　　leftURL	  {string}	点击左边按钮，跳转的链接地址，未设置leftJS有效
 *   　　rightURL	  {string}	点击右边按钮，跳转的链接地址，未设置rightJS有效
 *   　　animated   {number}  跳转是否有动画，0为没有，1为有
 *   　　showLoadingPage   {number}    0:不显示loading效果，1：显示loading效果
 * @param {boolean} needCloseCurrentView 是否需要关闭当前webview
 */
export const openPage = jssdk.openPage;
/**
 * 定制页面标题和左右按钮 2012
 * @function openPage
 * @param {OpenParams} params 参数
 *   　　fullScreen	{number}	是否全屏展示 0-否，1-是  在展示资讯内容的时候有需要全屏展示
 *   　　title	    {string}	页面的标题，如果不传或者传空，在load结束时，使用H5的标题。
 *   　　leftType	  {number}	"按钮类型 v0-没有按钮  1-返回 98-图片自定义(设置按钮为图片格式)" 99-自定义(设置为默认底图，显示对应文本)"
 *   　　rightType	{number}	类型同上
 *   　　leftText	  {string}	当type=98时图片的地址，当type=99时按钮标题
 *   　　rightText	{string}	当type=98时图片的地址，当type=99时右边按钮标题
 *   　　leftJS	    {string}	点击左边按钮，调用的js函数名或者js语句块，客户端直接调用即可，如果是函数，H5传值需为”functionName()”而不是functionName。
 *   　　rightJS	  {string}	点击右边按钮，调用的js函数名或者js语句块，客户端直接调用即可，如果是函数，H5传值需为”functionName()”而不是functionName。
 *   　　leftURL	  {string}	点击左边按钮，跳转的链接地址，未设置leftJS有效
 *   　　rightURL	  {string}	点击右边按钮，跳转的链接地址，未设置rightJS有效
 *   　　animated   {number}  跳转是否有动画，0为没有，1为有
 *   　　showLoadingPage   {number}    0:不显示loading效果，1：显示loading效果
 * @param {boolean} needCloseCurrentView 是否需要关闭当前webview
 */
export const setTitle = jssdk.setTitle;
/**
 * 关闭当前webview 2009
 * @function closePage
 * @param {CloseParams} type 类型
 *    　　0	    返回到客户端页面堆栈中的上一个页面(默认为0)
 *    　　1	    返回到自选首页
 *    　　2	    返回到行情首页
 *    　　3	    返回到普通交易首页
 *    　　4	    返回到信用交易首页
 *    　　5	    返回到首页
 *    　　6	    返回到自选-组合
 *    　　7	    返回到“我的“首页
 *        8     返回到"理财"首页
 *    　　98	   返回到指定页面，需传第二个参数，指定返回的backUrl
 *       99     自定义返回页面（仅支持web页面跳转）
 *
 * @param {object} args 其他传参
 *      当type=98时，定义backUrl为具体返回url
 *
 */
export const closePage = jssdk.closePage;
/**
	* 弹出提示框 3003
	* @function showAlert
	* @param {string} content 显示内容
	* @param {string} title 显示标题
	*/
export const showAlert = jssdk.showAlert;


/**
	 * 弹出确认提示框
	 * @function showConfirm
	 * @param {string} content 显示内容
	 * @param {function} onConfirm 点击确定后回调
	 * @param {function} onCancel 点击取消后回调
	 * @param {function} confirmTitle 确定键标题
	 * @param {function} cancelTitle 取消键标题
	*/
export const showConfirm = jssdk.showConfirm;

/**
 * onAppear 2011
 * @function onSkinChanged
 * @param {any} fn
 */
export const onSkinChanged = jssdk.onSkinChanged;

/**
 * onAppear 2011
 * 注意：回调中立即执行window.alert会阻塞IOS页面跳转
 * @function onAppear
 * @param {any} fn
 */
export const onAppear = jssdk.onAppear;
/**
 * onDisappear 2011
 * 注意：回调中立即执行window.alert会阻塞IOS页面跳转
 * @function onDisappear
 * @param {function} fn
 */
export const onDisappear = jssdk.onDisappear;
/**
 * onClose 2011
 * 注意：回调中立即执行window.alert会阻塞IOS页面跳转
 * @function onClose
 * @param {function} fn
 */
export const onClose = jssdk.onClose;
/**
 * onBackKeyPressed 2011
 * 注意：回调中立即执行window.alert会阻塞IOS页面跳转
 * @function onBackKeyPressed
 * @param {any} fn
 */
export const onBackKeyPressed = jssdk.onBackKeyPressed;
/**
 * 拨打电话 3000
 * @function call
 * @param {string} phoneNumber 电话号码（座机、手机）
 */
export const call = jssdk.call;
/**
 * 客户端打开其它App 3002
 * @function openApp
 * @param {OpenAppParams} param
 */
export const openApp = jssdk.openApp;
/**
 * 选择照片 3004
 * @function chooseImg
 * @param {ChooseImgParams} param
 *  {<br />
 *  source: 0-从相册选择，1-拍照　<br />
 *  front: 0-后置摄像头，1-前置摄像头<br />
 *  size: 客户端需要将图片高或者宽中较大的一边，缩小到这个size，然后将另一边按比例缩放<br />
 *  compressionQuality:JPEG压缩比例，范围为0.0-1.0。size和压缩比暂定1200和0.6，后续可调整。<br />
 *  floatingLayer：　浮层类型，仅在source为1时生效。0没有，1身份证正面（人头），2身份证反面（国徽），3自拍头像。<br />
 * }<br />
 * @returns {Promise<object>} 返回值<br/>
 *  code 0成功，1失败，2取消。<br />
 *  result.data: base64编码的图片信息
 */
export const chooseImg = jssdk.chooseImg;
/**
 * AnyChat视频见证 3005
 * @function startAnyChat
 * @param {StartAnyChatParams} param
 * @returns  {Promise<object>}
 */
export const startAnyChat = jssdk.startAnyChat;
/**
 * 二维码扫描 3007
 * @function scanCode
 * @returns  {Promise<object>}
 */
export const scanCode = jssdk.scanCode;
/**
 * 客户端本地录制视频 3009
 * @function chooseVideo
 * @param {ChooseVideoParams} param
 *  {
 *  front	number	0代表非前置（后置）摄像头，1代表前置摄像头。
 *  width	number	视频宽度
 *  height	number	视频高度
 *  duration	number	视频最大长度，单位秒，默认-1，不限制视频长度。
 *  bitRate	number	码率
 *  fps	number	帧数
 *  title	string	录制屏幕上方显示的标题（例如“请用标准普通话匀速朗读”）
 *  content	string	录制屏幕上方显示的正文（例如“本人自愿在国金证券开户”）
 * }
 * @returns {Promise<object>} Promise<object>
 *  code 0成功，1失败，2取消。
 *  result.filePath: 客户端存储视频的本地路径。
 *  result.fileSize: 视频文件大小
 *  result.duration: 视频文件长度
 */
export const chooseVideo = jssdk.chooseVideo;
/**
	* 支付宝支付 3012
	* @function goAlipay
	* @param {String} order 对应支付宝支付的参数orderString
	* @returns {Promise<object>}  支付宝支付返回的信息
	*
	*/
export const goAlipay = jssdk.goAlipay;
/**
 * 微信支付 3013
 * @function goWeChatPayment
 * @param {String} appId 商家向财务通申请的appId
 * @param {String} partnerId 商家向财务通申请的商家id
 * @param {String} prepayId 预支付订单
 * @param {String} nonceStr 随机串,防重发
 * @param {String} timeStamp 时间串,防重发
 * @param {String} packageStr 商家根据财付通文档填写的数据和签名
 * @param {String} sign 商家根据微信开放平台文档对数据做的签名
 * @returns {Promise<object>} 微信支付返回的信息
 */
export const goWeChatPayment = jssdk.goWeChatPayment;
/**
 * 微信分享 3015
 * @function goWeChatShare
 * @param {any} param 分享参数 (第三方参数透传,请查看native文档)
 * @returns {Promise<object>} 微信分享返回的信息
 */
export const goWeChatShare = jssdk.goWeChatShare;
/**
 * 金融登录-通用于获取uKey 4000, 扩展支持了fundAccount和版本号判断
 * @function
 * @param {LoginParams} params
 * @param {Promise<object>}  结果:0 - 登录成功; 1 - 取消登录; 其他值-换登功能号返回
 */
export const login = jssdk.login;
/**
 * 登录代入资金账号-调用前需要判断版本号 4030
 * @function
 * @param {LoginParams} params
 * @param {Promise<object>}  结果:0 - 登录成功; 1 - 取消登录; -2 - 参数格式错误; 其他值-换登功能号返回
 */
export const loginWithAccount = jssdk.loginWithAccount;
/**
 * 注销登录 4001
 * @function logout
 * @param {LogoutParams} param
 *      登录类型： <br>
 *              1-普通登录<br>
 *              2-信用登录<br>
 *              3-担保品划转登录（普通+信用）<br>
 *              4-通行证passport登录<br>
 *              5-普通+passort登录<br>
 */
export const logout = jssdk.logout;
/**
 * 客户端本地页面跳转 4002
 * @function clientJump
 * @param {ClientJumpParams} param
 */
export const clientJump = jssdk.clientJump;
/**
 * 完成适当性测评,关闭webview，继续登录前的操作 4009
 * @function doneSuitability
 * @param {number} loginType 登录类型 见：login
 * @param {number} isValid  是否完成：0-未完成，1-已完成
 */
export const doneSuitability = jssdk.doneSuitability;
/**
	* 获取登录状态 4012
	* @function getLoginStatus
	* @param {function} callback callback接收结果作为参数
	*/
export const getLoginStatus = jssdk.getLoginStatus;
/**
	* 获取与channelId对应的ukey 4012
	* @function getUkeyByChannelId
	* @param {String} channelId 渠道编号
	* @returns {Promise<object>}  获取成功后，callback接收ukey作为参数（获取失败时，返回null）
	*/
export const getUkeyByChannelId = jssdk.getUkeyByChannelId;
/**
 * 获取与channelId对应的userUKeys 4012
 * @param {String} channelId 渠道编号
 * @function getUserUKeys
 * @returns {Promise<object>}  获取成功后，callback接收ukey作为参数（获取失败时，返回null）
 */
export const getUserUKeysByChannelId = jssdk.getUserUKeysByChannelId;
/**
 * user登录 4015
 * 回调函数接收返回结果，结果:0 - 登录成功; 1 - 取消登录
 * @function userLogin
 * @returns {Promise<object>} 回调函数接收返回结果，结果:0 - 登录成功; 1 - 取消登录
 */
export const userLogin = jssdk.userLogin;
/**
 * user登录用户登录（一键登录弹窗） 4028
 * 回调函数接收返回结果，结果:0 - 登录成功; 1 - 取消登录
 * @function userLoginModal
 * @returns {Promise<object>} 回调函数接收返回结果，结果:0 - 登录成功; 1 - 取消登录
 */
export const userLoginModal = jssdk.userLoginModal;
/**
 * 往客户端磁盘写文件-依赖内部环境 2004
 * @param {SaveFileInDiskParams} param
 * @function saveFileInDisk
 * @returns {void}
 */
export const saveFileInDisk = jssdk.saveFileInDisk;
/**
 * 读客户端磁盘文件-依赖内部环境 2005
 * @param {ReadFileInDiskParams} param
 * @function readFileInDisk
 * @returns {Promise<object>}  文件内容
 */
export const readFileInDisk = jssdk.readFileInDisk;
/**
 *  获取PassportId-依赖内部环境 4004
 * @param {SaveFileInDiskParams} param
 * @function hybridGetPassport
 * @returns {void}
 */
export const hybridGetPassport = jssdk.hybridGetPassport;
/**
 * 获取usertId-依赖内部环境 4004
 * @param {SaveFileInDiskParams} param
 * @function hybridGetUserId
 * @returns {void}
 */
export const hybridGetUserId = jssdk.hybridGetUserId;
/**
 * 添加股票至自选股 4011
 * @function addToPortfolio
 * @param {PortfolioParams} param 参数
 * @returns {Promise<object>} 返回值
 */
export const addToPortfolio = jssdk.addToPortfolio;

/**
 * 删除股票自选股 4020
 * @function removePortfolio
 * @param {any} param 参数
 * @returns {Promise<object>} 返回值
 */
export const removePortfolio = jssdk.removePortfolio;

/**
 * 请求客户端非系统参数 4012
 * @function readNoSystemParameter
 * @param {ReadSystemParams} param
 * @returns {Promise}
 */
export const readNoSystemParameter = jssdk.readNoSystemParameter;
/**
 * 获取资金流向数据 4017
 * @function getCapital
 * @param {String} code 渠道编号
 * @param {number} codeType 渠道编号
 * @retruns {Promise<object>} 返回结果
 */
export const getCapital = jssdk.getCapital;

/**
 * 调用银联继承的apple pay支付功能 3020
 * @function appleUnionPay
 * @param {String} tn 交易流水号
 * @param {String} mID 苹果公司分配的商铺号
 * @param {String} mode "00" 代表接入生产环境 "01"代表接入开发测试环境
 * @retruns {Promise<object>} 返回结果
 */
export const appleUnionPay = jssdk.appleUnionPay;

/**
 * 调用银联继承的apple pay支付功能 3021
 * @function applePay
 * @param {object} orderInfo orderInfo
 * @param {String} mode "00" 代表接入生产环境 "01"代表接入开发测试环境
 * @retruns {Promise<object>} 返回结果
 */
export const appleChinaPay = jssdk.appleChinaPay;


/**
 * 设置statusBar样式 3016
 * @function setStatusBar
 * @param {StatusBarParams} param
 * @returns {Promise<object>}
 */
export const setStatusBar = jssdk.setStatusBar;

/**
 * 关闭webview的loading页面 3017
 * @function closeLoading
 * @returns {Promise<object>}
 */
export const closeLoading = jssdk.closeLoading;

/**
 * 活体检测 3018
 * @function VivoDetectionParams
 * @param {VivoDetectionParams} param
 * @returns {Promise<object>}
 */
export const vivoDetection = jssdk.vivoDetection;

/**
 * 申请系统权限（安卓） 3019
 * @function applyPermission
 * @param {ApplyPermissionParams} param
 * @returns {Promise<object>}
 */
export const applyPermission = jssdk.applyPermission;

/**
 * 添加日历事件 3022
 * @function addCalendar
 * @param {AddCalendarParams} param
 * @returns {Promise<object>}
 */
export const addCalendar = jssdk.addCalendar;

/**
 * 查询日历事件 3023
 * @function selectCalendar
 * @param {SelectCalendarParams} param
 * @returns {Promise<object>}
 */
export const selectCalendar = jssdk.selectCalendar;

/**
 * 删除日历事件 3024
 * @function vivoDetection
 * @param {DeleteCalendarParams} param
 * @returns {Promise<object>}
 */
export const deleteCalendar = jssdk.deleteCalendar;


/*
	* @functionCode 功能号：3038
	* @description  保存图片到相册
	* @param {String} data 参数-图片地址（首先要对图片进行base64处理）
	* @param {Number} imageType 参数-图片类型0-jpg，1-png（安卓）
   */
export const savePictureToPhone = jssdk.savePictureToPhone;

/**
  * 跳转微信客服页面	 3039
  * @function goWechatCustomService
  * @param {goWechatCustomServiceParams} param
  * @retruns {Promise<object>} 返回结果
 */
export const goWechatCustomService = jssdk.goWechatCustomService;
